<div class="container mt-4" style="min-height: calc(100vh - 300px);">
  <div class="row">
    <div class="col-lg-12">

      <div class="d-flex align-items-center justify-content-between">
        <h4 class="font-medium election-title">📈 Planning and development</h4>
        <button type="button" class="btn btn-primary btn-sm" (click)="goToReportPage()">Back To
          Report Page </button>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between gap-2">
            <h5 class="font-medium m-0">📄 Investment Made During The Month</h5>
            <!-- <button type="text" class="btn btn-primary btn-sm" data-bs-toggle="modal" 
                            >+ Add</button> -->
            <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
              data-bs-target="#InvestmentMadeDuringMonth">
              + Add
            </button>

            <!-- Modal -->
            <div class="modal fade" id="InvestmentMadeDuringMonth" data-bs-backdrop="static" data-bs-keyboard="false"
              tabindex="-1" aria-labelledby="InvestmentMadeDuringMonthLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                  <div class="modal-header">
                    <h1 class="modal-title fs-5" id="InvestmentMadeDuringMonthLabel">Investment Made
                      During The Month
                    </h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <form [formGroup]="sanctionForm" (ngSubmit)="onSubmit()">
                    <div class="modal-body">

                      <div class="row">
                        <!-- Head of Account -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label m-0">Head of Account<sup class="text-danger">*</sup></label>
                          <select class="form-control" formControlName="headAccount">
                            <option value="" disabled selected>--Select--</option>
                            <option *ngFor="let block of headData" [value]="block?.id">
                              {{ block?.accountHead }}
                            </option>
                          </select>
                          <div class="text-danger small"
                            *ngIf="(sanctionForm.get('headAccount')?.touched || isSubmitted) && sanctionForm.get('headAccount')?.errors?.['required']">
                            Head of Account is required
                          </div>
                        </div>

                        <!-- Date -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
                          <input type="date" class="form-control" formControlName="date">
                          <div class="text-danger small"
                            *ngIf="(sanctionForm.get('date')?.touched || isSubmitted) && sanctionForm.get('date')?.errors?.['required']">
                            Date is required
                          </div>
                        </div>

                        <!-- Sanction No -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label m-0">Sanction No<sup class="text-danger">*</sup></label>
                          <input type="text" class="form-control" placeholder="Please Enter" formControlName="sanction"
                            (keypress)="numberOnly($event)" maxlength="10">
                          <div class="text-danger small" *ngIf="(sanctionForm.get('sanction')?.touched || isSubmitted)">
                            <span *ngIf="sanctionForm.get('sanction')?.errors?.['required']">Sanction
                              number is required</span>
                            <span *ngIf="sanctionForm.get('sanction')?.errors?.['pattern']">Only
                              numbers are allowed</span>
                          </div>
                        </div>

                        <!-- Amount Sanction -->
                        <div class="col-md-6 mb-3">
                          <label class="form-label m-0">Amount Sanction<sup class="text-danger">*</sup></label>
                          <input type="text" class="form-control" placeholder="Please Enter"
                            formControlName="amountSanction" (keypress)="numberOnly($event)" maxlength="10">
                          <div class="text-danger small"
                            *ngIf="(sanctionForm.get('amountSanction')?.touched || isSubmitted)">
                            <span *ngIf="sanctionForm.get('amountSanction')?.errors?.['required']">Amount
                              Sanction is required</span>
                            <span *ngIf="sanctionForm.get('amountSanction')?.errors?.['pattern']">Only
                              numbers are allowed</span>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Head of Account</th>
                  <th>Date</th>
                  <th>Sanction No</th>
                  <th>Amount Sanctioned</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of investmentData; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.accountHead }}</td>
                  <td>{{ item.date | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ item.sanction }}</td>
                  <td>{{ item.amountSanction | number }}</td>
                  <td *ngIf="!isViewMode">
                    <button type="button" class="btn btn-danger btn-sm" (click)="deleteRow(item.id)">
                      <i class="bi bi-trash3"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>



    <!-- <div class="col-lg-3 col-md-6 mb-3">
            <label class="form-label m-0">Block<sup class="text-danger">*</sup></label>
            <select class="form-control">
                <option value="" selected disabled>-- Select Block --</option>
            </select>
        </div>

        <div class="col-lg-3 col-md-6 mb-3">
            <label class="form-label m-0">Coop. Society<sup class="text-danger">*</sup></label>
            <select class="form-control">
                <option value="" selected disabled>-- Select Coop. Society -- </option>
            </select>
        </div>

        <div class="col-lg-3 col-md-6 mb-3">
            <label class="form-label m-0">Type of Coop. Society<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" placeholder="Please Enter" readonly value="-- N/A --" />
        </div>

        <div class="col-lg-3 col-md-6 mb-3">
            <label class="form-label m-0">Outstanding Govt. Investment up to<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" placeholder="Please Enter">
        </div>

      

        <div class="col-lg-12">
            <div class="card">

                <div class="card-header">
                    <h5 class="m-0">📄 Govt. Share Redeemed during the month under major head (0425-00-800-06)</h5>
                </div>

                <div class="card-body">
                    <div class="row">

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
                            <input type="date" class="form-control" placeholder="DD/MM/YYYY">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Challan No<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
                            <input type="file" class="form-control">
                        </div>

                        <div class="col-lg-12">
                            <hr>
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Total Govt. Share amount redeemed up to the end of month<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Net Govt. Investment at the end of the month<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Outstanding dividend payable up to the previous month<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="m-0">📄 Dividend Deposited during the Month</h5>
                </div>
                <div class="card-body">
                    <div class="row">

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Total Amount of Dividend Deposited up to the end of the
                                Month<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Outstanding Dividend Payable up to the end of the Month<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="m-0">📄 0050-00-200-05 for Coop. Banks</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
                            <input type="date" class="form-control" placeholder="DD/MM/YYYY">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Challan No.<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
                            <input type="file" class="form-control">
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="m-0">📄 0050-00-200-01 for Coop. Societies</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
                            <input type="date" class="form-control" placeholder="DD/MM/YYYY">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Challan No<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
                            <input type="file" class="form-control">
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 text-end mb-4">
            <button type="submit" class="btn btn-primary">Save</button>
        </div> -->
  </div>


  <!-- <div class="row">

  

    <div class="col-lg-3 col-md-6 mb-3">
      <label class="form-label m-0">Block<sup class="text-danger">*</sup></label>
      <select class="form-control">
        <option value="" selected disabled>-- Select Block --</option>
      </select>
    </div>

    <div class="col-lg-3 col-md-6 mb-3">
      <label class="form-label m-0">Coop. Society<sup class="text-danger">*</sup></label>
      <select class="form-control">
        <option value="" selected disabled>-- Select Coop. Society -- </option>
      </select>
    </div>

    <div class="col-lg-3 col-md-6 mb-3">
      <label class="form-label m-0">Type of Coop. Society<sup class="text-danger">*</sup></label>
      <input type="text" class="form-control" placeholder="Please Enter" readonly value="-- N/A --" />
    </div>

    <div class="col-lg-3 col-md-6 mb-3">
      <label class="form-label m-0">Outstanding Govt. Investment up to<sup class="text-danger">*</sup></label>
      <input type="text" class="form-control" placeholder="Please Enter">
    </div>


    <div class="col-lg-12">
      <div class="card">

        <div class="card-header">
          <h5 class="m-0">📄 Govt. Share Redeemed during the month under major head (0425-00-800-06)</h5>
        </div>

        <div class="card-body">
          <div class="row">

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
              <input type="date" class="form-control" placeholder="DD/MM/YYYY">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Challan No<sup class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
              <input type="file" class="form-control">
            </div>

            <div class="col-lg-12">
              <hr>
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Total Govt. Share amount redeemed up to the end of month<sup
                  class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Net Govt. Investment at the end of the month<sup
                  class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Outstanding dividend payable up to the previous month<sup
                  class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h5 class="m-0">📄 Dividend Deposited during the Month</h5>
        </div>
        <div class="card-body">
          <div class="row">

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Total Amount of Dividend Deposited up to the end of the Month<sup
                  class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Outstanding Dividend Payable up to the end of the Month<sup
                  class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h5 class="m-0">📄 0050-00-200-05 for Coop. Banks</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
              <input type="date" class="form-control" placeholder="DD/MM/YYYY">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Challan No.<sup class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
              <input type="file" class="form-control">
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h5 class="m-0">📄 0050-00-200-01 for Coop. Societies</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
              <input type="date" class="form-control" placeholder="DD/MM/YYYY">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Challan No<sup class="text-danger">*</sup></label>
              <input type="text" class="form-control" placeholder="Please Enter">
            </div>

            <div class="col-lg-3 col-md-6 mb-2">
              <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
              <input type="file" class="form-control">
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 text-end mb-4">
      <button type="submit" class="btn btn-primary">Save</button>
    </div>

  </div> -->


  <form [formGroup]="progressForm" (ngSubmit)="saveFormDetail()" novalidate>
    <div class="row">
      <!-- Block -->
      <div class="col-lg-3 col-md-6 mb-3">
        <label class="form-label m-0">Block<sup class="text-danger">*</sup></label>
        <select class="form-control" formControlName="blockOfficeId">
          <option value="" selected>--Select--</option>
          <option *ngFor="let block of blockList" [value]="block?.iBlockId">
            {{ block?.sBlockName }}
          </option>
        </select>
        <div class="text-danger small"
          *ngIf="(progressForm.get('blockOfficeId')?.touched || isSubmitted) && progressForm.get('blockOfficeId')?.errors?.['required']">
          Block is required
        </div>
      </div>

      <!-- Coop Society Type -->
      <div class="col-lg-3 col-md-6 mb-3">
        <label class="form-label m-0">Type of Coop. Society<sup class="text-danger">*</sup></label>

        <select class="form-control" formControlName="coopSocietiesType" (change)="getSociety($event,false)">
          <option value="" disabled>-- Select Type of Coop. Society --</option>
          <option *ngFor="let item of societyTypeList" [value]="item?.id">
            {{ item?.typeName }}
          </option>
        </select>

        <div class="text-danger small"
          *ngIf="(progressForm.get('coopSocietiesType')?.touched || isSubmitted) && progressForm.get('coopSocietiesType')?.errors?.['required']">
          Type of Coop. Society is required
        </div>
      </div>
      <!-- Coop Society -->
      <div class="col-lg-3 col-md-6 mb-3">
        <label class="form-label m-0">Coop. Society<sup class="text-danger">*</sup></label>
        <!-- Society -->
        <select class="form-control" formControlName="coopSocieties">
          <option value="" disabled>-- Select Coop. Society --</option>
          <option *ngFor="let item of societyList" [value]="item?.id">
            {{ item?.name }}
          </option>
        </select>

        <div class="text-danger small"
          *ngIf="(progressForm.get('coopSocieties')?.touched || isSubmitted) && progressForm.get('coopSocieties')?.errors?.['required']">
          Coop. Society is required
        </div>
      </div>



      <!-- Govt Investment -->
      <div class="col-lg-3 col-md-6 mb-3">
        <label class="form-label m-0">Outstanding Govt. Investment up to<sup class="text-danger">*</sup></label>
        <input type="text" maxlength="10" class="form-control" formControlName="govtInvestment"
          placeholder="Enter Amount" (keypress)="allowNumbersOnly($event)">
        <div class="text-danger small"
          *ngIf="(progressForm.get('govtInvestment')?.touched || isSubmitted) && progressForm.get('govtInvestment')?.errors?.['required']">
          Govt. Investment is required
        </div>
      </div>

      <!-- GOVT SHARE SECTION -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="m-0">📄 Govt. Share Redeemed during the month (0425-00-800-06)</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
                <input type="date" class="form-control" formControlName="gDate">
                <div class="text-danger small"
                  *ngIf="progressForm.get('gDate')?.errors?.['required'] && (progressForm.get('gDate')?.touched || isSubmitted)">
                  Date is required
                </div>
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Challan No<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="gChallanNo"
                  placeholder="Enter Challan No">
                <div class="text-danger small"
                  *ngIf="progressForm.get('gChallanNo')?.errors?.['required'] && (progressForm.get('gChallanNo')?.touched || isSubmitted)">
                  Challan No is required
                </div>
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="gAmount"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
                <div class="text-danger small"
                  *ngIf="progressForm.get('gAmount')?.errors?.['required'] && (progressForm.get('gAmount')?.touched || isSubmitted)">
                  Amount is required
                </div>
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
                <input type="file" class="form-control" formControlName="gUploadChallan"
                  (change)="onFileChange($event, 'gUploadChallan')" accept=".pdf">
                <div class="text-danger small"
                  *ngIf="progressForm.get('gUploadChallan')?.errors?.['required'] && progressForm.get('gUploadChallan')?.touched">
                  Challan PDF is required
                </div>
              </div>

              <div class="col-lg-12">
                <hr>
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Total Govt. Share Redeemed<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="tGovtShare"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
                <div class="text-danger small"
                  *ngIf="progressForm.get('tGovtShare')?.errors?.['required'] && (progressForm.get('tGovtShare')?.touched || isSubmitted)">
                  This field is required
                </div>
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Net Govt. Investment<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="tGovtInvestment"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
                <div class="text-danger small"
                  *ngIf="progressForm.get('tGovtInvestment')?.errors?.['required'] && (progressForm.get('tGovtInvestment')?.touched || isSubmitted)">
                  This field is required
                </div>
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Outstanding Dividend (Previous Month)<sup
                    class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="outstandingDividendPrevious"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
                <div class="text-danger small"
                  *ngIf="progressForm.get('outstandingDividendPrevious')?.errors?.['required'] && (progressForm.get('outstandingDividendPrevious')?.touched || isSubmitted)">
                  This field is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DIVIDEND SECTION -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="m-0">📄 Dividend Deposited during the Month</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Total Amount Deposited<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="tAmountDevidendDeposite"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
                <div class="text-danger small"
                  *ngIf="progressForm.get('tAmountDevidendDeposite')?.errors?.['required'] && (progressForm.get('tAmountDevidendDeposite')?.touched || isSubmitted)">
                  Total Dividend Amount is required
                </div>
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Outstanding Dividend Payable<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="outstandingDividendEnd"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
                <div class="text-danger small"
                  *ngIf="progressForm.get('outstandingDividendEnd')?.errors?.['required'] && (progressForm.get('outstandingDividendEnd')?.touched || isSubmitted)">
                  Outstanding Dividend is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- COOP BANKS -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="m-0">📄 0050-00-200-05 for Coop. Banks</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
                <input type="date" class="form-control" formControlName="coopBankDate">
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="coopBankAmount"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Challan No.<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="coopBankChallanNo"
                  placeholder="Enter Challan No">
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
                <input type="file" class="form-control" formControlName="coopBankUploadChallan"
                  (change)="onFileChange($event, 'coopBankUploadChallan')" accept=".pdf">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- COOP SOCIETIES -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="m-0">📄 0050-00-200-01 for Coop. Societies</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Date<sup class="text-danger">*</sup></label>
                <input type="date" class="form-control" formControlName="coopSocietiesDate">
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Amount<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="coopSocietiesAmount"
                  (keypress)="allowNumbersOnly($event)" placeholder="Enter Amount">
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Challan No<sup class="text-danger">*</sup></label>
                <input type="text" maxlength="10" class="form-control" formControlName="coopSocietiesChallanNo"
                  placeholder="Enter Challan No">
              </div>

              <div class="col-lg-3 col-md-6 mb-2">
                <label class="form-label m-0">Upload Challan<sup class="text-danger">*</sup></label>
                <input type="file" class="form-control" formControlName="coopSocietiesUploadChallan"
                  (change)="onFileChange($event, 'coopSocietiesUploadChallan')" accept=".pdf">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 text-end mb-4" *ngIf="!isViewMode">
        <button type="submit" class="btn btn-primary">Save</button>
      </div>
    </div>
  </form>




</div>